<template>
    <div class="max-w-site mx-auto">
        <pageLoader v-if="!pageLoaded" />
        <div v-if="!!pageLoaded" class="flex flex-col mt-16">
            <div class="mx-auto text-3xl font-bold">
                {{
                    $t(
                        status === 'success'
                            ? '您的電郵地址已經確認'
                            : errors.server
                    )
                }}
            </div>
            <router-link
                class="btn border-0 font-black text-secondary mx-auto mt-8"
                tag="button"
                to="/"
            >
                <div class="icon">
                    <chevronLeft />
                </div>
                {{ $t('notFound.back.home') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import pageLoader from '@/components/pageLoader.vue';
import chevronLeft from '../../assets/svg/chevron_left.svg';

import { instance } from '@/utils/ajax';

async function confirmEmailAddress(form) {
    try {
        let result = await instance.post(
            '/api/accountInfo/confirmEmailAddress',
            form
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error confirm email address');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: { pageLoader, chevronLeft },
    data() {
        return {
            pageLoaded: false,
            status: undefined,
            errors: {}
        };
    },
    async created() {
        this.pageLoaded = false;
        const token = this.$route.params.token;
        const result = await confirmEmailAddress({ token });
        if (result.success) {
            this.status = 'success';
        } else {
            this.status = 'fail';
            this.errors = result.data.errors;

            if (this.errors && this.errors.server) {
                this.rediectToLoginTimeout = setTimeout(() => {
                    this.$router.push('/login');
                }, 2 * 1000);
            }
        }
        this.pageLoaded = true;
    },
    beforeDestroy() {
        if (this.rediectToLoginTimeout)
            clearTimeout(this.rediectToLoginTimeout);
    }
};
</script>
